import { Component, HostBinding, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faQuestionCircle, faThumbsDown, faThumbsUp } from '@fortawesome/free-regular-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { Subscription } from 'rxjs';

import { faCommentSlash } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from './core/services/auth.service';
import { FreshdeskWidgetService } from './core/services/freshdesk-widget.service';
import { HistoryService } from './core/services/history.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit, OnDestroy {
  @HostBinding('@.disabled')
  public animationsDisabled = false;

  private onLangChange = new Subscription();

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private auth: AuthService,
    private freshdeskWidget: FreshdeskWidgetService,
    private ccService: NgcCookieConsentService,
    private translate: TranslateService,
    private historyService: HistoryService, /* Ensure service is initialized eagerly */
    iconLibrary: FaIconLibrary
  ) {
    iconLibrary.addIcons(faQuestionCircle, faThumbsUp, faThumbsDown, faCommentSlash);
  }

  ngOnInit(): void {
    this.onLangChange.add(this.onLangChange = this.translate.onLangChange.subscribe(lang => {
      this.showCookieBanner();
    }));

    this.onLangChange.add(this.auth.loginDetails$.subscribe(async details => {
      if (details) {
        await this.freshdeskWidget.hide('launcher');
      } else {
        await this.freshdeskWidget.destroy();
      }
    }));
  }

  ngOnDestroy(): void {
    this.onLangChange.unsubscribe();
  }

  toggleAnimations() {
    this.animationsDisabled = !this.animationsDisabled;
  }
  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  showCookieBanner() {
    this.translate.get(['generic.cookie.message', 'generic.cookie.onlyanalytics', 'generic.cookie.dismiss', 'generic.cookie.link', 'generic.cookie.url', 'generic.cookie.privacy', 'generic.cookie.accessibility', 'generic.cookie.accessibilityUrl'])
      .subscribe(translations => {
        this.ccService.getConfig().content = this.ccService.getConfig().content || {};
        this.ccService.getConfig().content!.message = translations['generic.cookie.message'];
        this.ccService.getConfig().content!.deny = translations['generic.cookie.onlyanalytics'];
        this.ccService.getConfig().content!.allow = translations['generic.cookie.dismiss'];
        this.ccService.getConfig().content!.link = translations['generic.cookie.link'];
        this.ccService.getConfig().content!.href = translations['generic.cookie.url'];
        this.ccService.getConfig().content!['privacy'] = translations['generic.cookie.privacy'];
        this.ccService.getConfig().content!['accessibility'] = translations['generic.cookie.accessibility'];
        this.ccService.getConfig().content!['accessibilityHref'] = translations['generic.cookie.accessibilityUrl'];

        try {
          this.ccService.destroy();
        } catch (e) {
          // Ignore
        }
        this.ccService.init(this.ccService.getConfig());
      });
  }


}
